<mapfre-header></mapfre-header>
<div class="container mapfre-content">
  <mapfre-card
    additionalClasses="agent agent-content-width"
    additionalCardContentClasses="agent-content-width"
  >
  <div class="row text-center">
    <div class="col">
      <h1 class="title-copy title-font">{{ "Unsubscribe from this email" | translate }}</h1>
      <p class="grey-color margin-bottom mb24">{{ "Click unsubscribe to confirm you no longer wish to receive these emails" | translate }}</p>
      <div class="grey-color bold-letters font-size-notify">{{ "To resume receipt of these updates, send an email to:" | translate }}
        <a *ngIf="isACMIC" href="mailto:mapfreusa@service-now.com">{{'mapfreusa@service-now.com'}}</a>
        <a *ngIf="!isACMIC" href="mailto:agencyinterface@mapfreusa.com">{{'agencyinterface@mapfreusa.com'}}</a>
      </div>
    </div>
  </div>
  <mapfre-alert></mapfre-alert>

  <div class="row text-center margin-top mt24">
    <div class="col">
      <mapfre-button
        [additionalClasses]="'basic primary large-btn'"
        [ngClass]="{ custom_loader: loader }"
        [disabledValue]="!loader"
        (click)="unsubscribe()"
      >{{ 'UNSUBSCRIBE' }}</mapfre-button>
    </div>
  </div>

  <div class="row text-center margin-top mt16">
    <div class="col">
      <mapfre-button
        [additionalClasses]="'btn mapfre ghost primary medium-btn'"
        [ngClass]="{ custom_loader: loader }"
        [disabledValue]="!loader"
        (click)="onCancel()"
      >{{'CANCEL'}}</mapfre-button>
    </div>
  </div>
  
  </mapfre-card>
</div>
